import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { PiAirplaneTakeoffFill } from "react-icons/pi";
import { MdDateRange } from "react-icons/md";
import Form from "react-bootstrap/Form";
import { PiAirplaneLandingFill } from "react-icons/pi";
import { IoMdSearch } from "react-icons/io";
import Card from "react-bootstrap/Card";
import { CiGift } from "react-icons/ci";
import Accordion from "react-bootstrap/Accordion";
import { RxDoubleArrowDown } from "react-icons/rx";
import { FaCalendarAlt } from "react-icons/fa";
import { BsFillSuitcase2Fill } from "react-icons/bs";
import React, { useState, useEffect } from "react";
import { endPoints, Image_Url, clientId } from "../../Constant/Environment";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../redux/Actions/Actions";
import { getAllItemsData, addItemToken, getAllItemsToken } from "../../Utility/Api";
import { formatDate, formatDateByMonth, checkSubscription } from "../../Utility/AxiosInstance";
import { useNavigate } from "react-router-dom";
import swal from 'sweetalert';
import parse from 'html-react-parser';
import { RxCross2 } from "react-icons/rx";
import { Button } from "react-bootstrap";
import { getFullUrl } from "../../Constant/makeApiCall";
import MetaTags from '../MetaTags';
import Loader from '../Loader';
import { InfinitySpin } from 'react-loader-spinner'
import CitySelector from "../CitySelector/CitySelector";
import Swal from 'sweetalert2';
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import styled from 'styled-components';
import Modal from "react-bootstrap/Modal";
import { Country, State, City } from 'country-state-city';


function Home() {
  const [showPayPal, setShowPayPal] = useState(false);
  const [DepartureCity, setDepartureCity] = useState('');
  const [checkClear, setcheckClear] = useState(false);
  const [ArrivalCity, setArrivalCity] = useState('');
  const [FlightDate, setFlightDate] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  let navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const { contactData } = useSelector((state) => state.contactData);
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const [homePageData, setHomePageData] = useState({});
  const [faqsList, setFaqsList] = useState([]);

  const [senderAndTravelerInfo, setSenderAndTravelerInfo] = useState([]);

  const dispatch = useDispatch();
  const [itemsToShow, setItemsToShow] = useState(9);


  const handleLoadMore = () => {
    setItemsToShow(itemsToShow + 9);
  };
  const [filteredData, setFilteredData] = useState([]);


  useEffect(() => {
    if (senderAndTravelerInfo) {
      setFilteredData(senderAndTravelerInfo);
    }
  }, [senderAndTravelerInfo]);


  const getHomePageData = () => {
    setIsLoading(true);
    let url = `${endPoints.api.HOME_PAGE_DATA_FINAL}`;
    getAllItemsData(url)
      .then((response) => {
        const { status, data } = response;
        if (status === 200) {
          const { travelerData, homePage, faqData } = data;
          setHomePageData(homePage);
          setFaqsList(faqData);
          setSenderAndTravelerInfo(travelerData);
          setIsLoading(false)

        } else {
          // Handle error or show a message
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };


  useEffect(() => {
    getHomePageData();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const checkLogin = (id) => {
    if (isAuthenticated) {
      if (user.payment_status === 'Pending' || user.payment_status === 'Cancel') {
        Swal.fire({
          title: 'Error!',
          text: 'To send a parcel, please take a plan of membership account.',
          icon: 'error',
          showCancelButton: true,
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
        }).then((result) => {
          if (result.isConfirmed) handleOkClick();
        });
      } else if (user.payment_status === 'Success' || user.payment_status === 'COMPLETED') {
        navigate(`travel-information/${id}`);
      }
    } else {
      Swal.fire('Error!', "To send a parcel, please take a membership plan.", 'error');
    }
  };
  const handleOkClick = () => {
    setShowPayPal(true);
    setShowModal(true);
  };

  const [validated, setValidated] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!DepartureCity && !ArrivalCity && !FlightDate) {
      swal('Error!', "Please select at least one filter: Departure City, Arrival City, or Flight Date", 'error');
      return;
    }
    const filteredFlights = filteredData.filter(flight => {
      const flightDateObj = new Date(flight.travel_date);
      const searchDateObj = new Date(FlightDate);
      return (
        (!ArrivalCity || flight.toWhere === ArrivalCity) &&
        (!DepartureCity || flight.fromWhere === DepartureCity) &&
        (!FlightDate || flightDateObj.toDateString() === searchDateObj.toDateString())
      );
    });

    setFilteredData(filteredFlights);
    setcheckClear(true);
  };
  const clearFilter = async (event) => {
    setFilteredData(senderAndTravelerInfo);
    setArrivalCity("");
    setDepartureCity("");
    setcheckClear(false);
    setFlightDate("");
  }




  const handlePaymentComplete = async (paymentResult) => {
    const data = {
      userId: user?._id,
      payerID: paymentResult.payer.payer_id,
      paymentID: paymentResult.id,
      amount: paymentResult.purchase_units[0].amount.value,
      currency: paymentResult.purchase_units[0].amount.currency_code,
      status: paymentResult.status,
    };
    try {
      const url = `${endPoints.api.AddPaymentInfo}`;
      const response = await addItemToken(url, data);
      if (response.status === 200) {
        setShowModal(false)
        swal('Success!', "Payment  added successfully.", 'success');
        GetUserById();
      }
    } catch (error) {
      
      console.error(error);
    }
  };
  const GetUserById = () => {
    const storedAuthState = JSON.parse(localStorage.getItem("authState"));
    let url = user && user._id ? `${endPoints.api.GETBYSENDERID}/${user._id}` : `${endPoints.api.GETBYSENDERID}`;
    getAllItemsToken(url).then((response) => {
      dispatch({
        type: Actions.USERLOGIN,
        data: {
          user: response.final_data.users,
          travelerInfo: response.final_data.travelerInfoData,
          token: storedAuthState.token,
          payment: response.final_data.payment,
        },
      });
    });
  };

  const handlePaymentFailure = (error) => {
    console.error('Payment Failed:', error);
  };

  const handlePaymentTerminated = () => {
    console.log('Payment Terminated');
  };

  const handleCloseModal = () => setShowModal(false);
  return (
    <>

      {isLoading ? (
        // <Loader spinner={true} visible={isLoading} className="loader" />
        <div className="page_loader"><InfinitySpin
          visible={true}
          width="200"
          color="#4fa94d"
          ariaLabel="infinity-spin-loading"
        /></div>
      ) : (
        <>
          <MetaTags
            title={homePageData && homePageData.meta_title}
            description={homePageData && homePageData.meta_descriptions}
            image={Image_Url + homePageData.banner}
            canonicalUrl={getFullUrl()}
          />


          <section className=" home-banner banner-001">
            <Container fluid className=" p-0 position-relative">
              {homePageData && homePageData.banner ? (
                <img src={Image_Url + homePageData.banner} alt="banner" />
              ) : null}
              <Container>
                <Row>
                  <Col xs={6}>
                    <div className="banner-text">
                      <h1>
                        {homePageData && homePageData.title}
                      </h1>

                      <p>
                        {homePageData && homePageData.descriptions}
                      </p>
                    </div>
                  </Col>
                </Row>
              </Container>
              <Container className="booking-area">
                <Row className="g-4">
                  <Form validated={validated}
                    onSubmit={handleSubmit} className="Reative">
                    <Row className="g-3">
                      <Col md={3}>

                        <label>
                          <PiAirplaneTakeoffFill />
                          Departure City
                        </label>
                        <CitySelector

                          DepartureCity={DepartureCity}
                          setDepartureCity={setDepartureCity}
                          className="set"
                        />


                      </Col>
                      <Col md={3}>

                        <label>
                          <PiAirplaneLandingFill />
                          Arrival City
                        </label>
                        <CitySelector

                          DepartureCity={ArrivalCity}
                          setDepartureCity={setArrivalCity}
                        />


                      </Col>
                      <Col md={3}>

                        <label>
                          <MdDateRange />
                          Date
                        </label>

                        <input type="date" className="form-control" value={FlightDate}
                          onChange={(e) => setFlightDate(e.target.value)} />

                      </Col>
                      <Col md={1} xs={6}>
                        <label></label>
                        <Button
                          // to="/"
                          type="submit"
                          onSubmit={handleSubmit}

                          className="main-btn rounded-2 px-lg-3"
                        >
                          <IoMdSearch />
                          SEARCH
                        </Button>
                      </Col>
                      {checkClear &&
                        <Col md={1} xs={6}>
                          <Button

                            onClick={clearFilter}
                            className="main-btn rounded-2 px-lg-3  clearButton"
                          >
                            <RxCross2 />
                            Clear
                          </Button>
                        </Col>
                      }
                    </Row>
                  </Form>
                </Row>
              </Container>
            </Container>
          </section>

          <section className="sec-padd">
            <Container>
              <div className="filter-icon">
                <h2 className="c-heading text-center">Upcoming Travelers Trips</h2>
                <img
                  src={require("../../Assets/Images/filter.svg").default}
                  alt="logo1"
                />
              </div>

              <Row className="align-items-center g-5">
                {filteredData.length > 0 ? filteredData.slice(0, itemsToShow).map((data, index) => (
                  <Col md={4}>
                    <Card>
                      <div className="card1">
                        <Card.Img
                          variant="top"
                          src={
                            data.travelerDetails?.image
                              ? (Image_Url + data.travelerDetails.image).replace(/\\/g, '/')
                              : require(`../../Assets/Images/${data.travelerDetails?.gender === 'male' ? 'male-user' : 'female'}.png`)
                          }
                          alt={data.travelerDetails?.gender === 'male' ? 'Male' : 'Female'} decoding="async" loading="lazy" data-lazy="true"
                        />

                        <div className="card-text">
                          {isAuthenticated && Object.entries(user).length !== 0 && (user.payment_status === 'Success' || user.payment_status === 'COMPLETED') ? (
                            <>
                              <h6>{data.travelerDetails.first_name}</h6>
                            </>
                          ) : (
                            <h6>XXXX</h6>
                          )}
                          <p>{formatDate(data.created_at)}</p>
                        </div>
                      </div>

                      <Card.Body>
                        <div className="crdbdymn">
                          <div className="row">
                            <Col xs={6} className="pe-md-0 d-flex">
                              <div className="mncrd">
                                <div className="crdhdr">
                                  <PiAirplaneTakeoffFill />
                                  From
                                </div>
                                <div className="crdbdy">

                                  <p>
                                    {data.fromWhere}
                                  </p>

                                  <div className="crdftr">

                                    {(data.from_state_name)}
                                  </div>
                                </div>
                              </div>
                            </Col>
                            <Col xs={6} className="d-flex">
                              <div className="mncrd">
                                <div className="crdhdr">
                                  <PiAirplaneLandingFill />
                                  To
                                </div>
                                <div className="crdbdy">
                                  <p>{data.toWhere}</p>
                                  <div className="crdftr">

                                    {(data.to_state_name)}
                                  </div>
                                </div>
                              </div>
                            </Col>
                          </div>
                        </div>

                        <div className="ftrdv mb-4">
                          <FaCalendarAlt />
                          Travel Date: <span>{formatDateByMonth(data.travel_date)}</span>
                        </div>
                        <div className="ftrdvdwn mb-4">
                          <BsFillSuitcase2Fill />
                          Max Parcel Weight: <span>{data.maxWeight} Kg</span>
                        </div>
                        <div className="text-center">

                          <Button onClick={() => checkLogin(data._id)}>Send Package</Button>


                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                )
                ) : (
                  <p className="noOne">No data available.</p>
                )}


                {itemsToShow < filteredData.length && (
                  <div className="d-flex align-items-center justify-content-center mt-5">
                    <button className="view-btn" onClick={handleLoadMore}>
                      <RxDoubleArrowDown />
                      Load More
                    </button>
                  </div>
                )}

              </Row>
            </Container>
          </section>

          <section className="sec-padd middle">
            <Container>
              <h3 className="c-heading text-center mb-5">How It Works</h3>
              <Row className="g-5">
                <Col md={4}>
                  <div className="work-box">
                    <img
                      src={require("../../Assets/Images/home-img02.webp")}
                      alt="logo2"
                    />
                    <h4>
                      Find a matching <br />
                      traveler or sender
                    </h4>
                    <p>
                      Social Shipping matches travelers with extra luggage space to
                      senders who need to send packages along the same route.
                    </p>
                  </div>
                </Col>
                <Col md={4}>
                  <div className="work-box">
                    <img
                      src={require("../../Assets/Images/home-img03.webp")}
                      alt="logo2"
                    />
                    <h4>
                      Agree on <br />a delivery fee
                    </h4>
                    <p>
                      Traveler and sender negotiate a delivery fee using Social
                      Shipping. Payment information is provided to Social Shipping
                      as collateral.
                    </p>
                  </div>
                </Col>
                <Col md={4}>
                  <div className="work-box">
                    <img
                      src={require("../../Assets/Images/home-img01.webp")}
                      alt="logo2"
                    />
                    <h4>Deliver</h4>
                    <p>
                      Traveler carries package to destination and gets confirmation
                      code from recipient. Social Shipping transfers payment to
                      traveler on successful confirmation of delivery.
                    </p>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

          <section className="sec-padd">
            <Container>
              <h3 className="c-heading text-center">FAQ For Senders</h3>
              <p className="text-center mb-5 gray-color">
                How to send parcels with Social Shipping
              </p>
              <Row className="align-items-center justify-content-center">
                <Col md={12}>
                  <Accordion defaultActiveKey="0">
                    {faqsList.map((data, index) => (
                      <>
                        {data.faq_type === 'Sender' &&
                          <Accordion.Item eventKey={index}>
                            <Accordion.Header>
                              <CiGift />
                              {data.title}
                            </Accordion.Header>
                            <Accordion.Body>
                              {parse(data.descriptions)}
                            </Accordion.Body>
                          </Accordion.Item>
                        }
                      </>
                    ))}

                  </Accordion>
                </Col>
              </Row>
            </Container>
          </section>

          <section className="sec-padd pt-0">
            <Container>
              <h3 className="c-heading text-center">FAQ For Travelers</h3>
              <p className="text-center mb-5">
                How to deliver parcels with Social Shipping and make money
              </p>
              <Row className="align-items-center justify-content-center">
                <Col md={12}>
                  <Accordion defaultActiveKey="0">
                    {faqsList.map((data, index) => (
                      <>
                        {data.faq_type === 'Traveler' &&
                          <Accordion.Item eventKey={index}>
                            <Accordion.Header>
                              <CiGift />
                              {data.title}
                            </Accordion.Header>
                            <Accordion.Body>
                              {parse(data.descriptions)}
                            </Accordion.Body>
                          </Accordion.Item>
                        }
                      </>
                    ))}

                  </Accordion>
                </Col>
              </Row>
            </Container>
          </section>
        </>
      )}
      {showPayPal && (
        <div className="paypal-section">
          <Modal show={showModal} onHide={handleCloseModal} centered>
            <Modal.Header closeButton>
              <Modal.Title>PayPal Payment</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <PayPalScriptProvider options={{ "client-id": clientId }}>
                <PayPalButtons
                  style={{ layout: "vertical" }}
                  createOrder={(data, actions) => {
                    return actions.order.create({
                      payer: {
                        name: {
                          given_name: user?.first_name || '',
                          surname: user?.lastName || '',
                        },
                        email_address: user?.email || '',
                        phone: {
                          phone_type: 'MOBILE',
                          phone_number: {
                            national_number: user?.mobile || '',
                          },
                        },
                        address: {
                          admin_area_1: user?.state_name || 'CA',
                          admin_area_2: user?.city_name || 'San Jose',
                          country_code: user?.country || 'US',
                        },
                      },
                      purchase_units: [{
                        amount: {
                          value: contactData ? contactData.amount : 0,
                        },
                      }],
                    });
                  }}
                  onApprove={(data, actions) => {
                    return actions.order.capture().then((details) => {
                      handlePaymentComplete(details);
                    });
                  }}
                  onError={(err) => {
                    handlePaymentFailure(err);
                  }}
                  onCancel={() => {
                    handlePaymentTerminated();
                  }}
                />
              </PayPalScriptProvider>
            </Modal.Body>
          </Modal>
        </div>
      )}
    </>
  );
}

export default Home;
